module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-e81f4af0.png";